import type { C1_Project } from "../model/C1_Project";
import type { C1_AxisData } from "../types/C1_ModelTypes";

function roundToTenCentimeters(value: number) {
  // toFixed normalisiert zusätzlich typische Fließkommaartefakte wie
  // 4.6000000000000005, sodass nur Werte im 10-cm-Raster gespeichert werden.
  return Number((Math.round((value + Number.EPSILON) * 10) / 10).toFixed(1));
}

/**
 * Skaliert alle vertikalen und horizontalen Achsen unabhängig voneinander
 * auf die gewünschten Außenmaße. Die relative Raumaufteilung bleibt erhalten.
 */
export function scaleAxesToBuildingDimensions(
  axes: C1_AxisData[],
  width: number,
  length: number,
): C1_AxisData[] {
  const boundsByKind = {
    v: axisBounds(axes, "v"),
    h: axisBounds(axes, "h"),
  };

  return axes.map((axis) => {
    const { first, last } = boundsByKind[axis.kind];
    const targetSize = roundToTenCentimeters(axis.kind === "v" ? width : length);
    const scaledPosition =
      last === first ? 0 : ((axis.pos - first) / (last - first)) * targetSize;

    // Das Runden erfolgt bewusst nach der vollständigen Skalierung jeder Achse.
    return { ...axis, pos: roundToTenCentimeters(scaledPosition) };
  });
}

/**
 * Wendet dieselbe Außenmaß-Transformation auf ein vorhandenes Projekt an,
 * die auch beim Erstellen eines Projekts aus einer Vorlage verwendet wird.
 */
export function transformProjectToBuildingDimensions(
  project: C1_Project,
  width: number,
  length: number,
) {
  const axes: C1_AxisData[] = [];
  for (const axis of state.axes) axes.push(axis.toJSON());
  project.replaceAxes(scaleAxesToBuildingDimensions(axes, width, length));
}

function axisBounds(axes: C1_AxisData[], kind: C1_AxisData["kind"]) {
  const positions = axes.filter((axis) => axis.kind === kind).map((axis) => axis.pos);
  return {
    first: positions.length ? Math.min(...positions) : 0,
    last: positions.length ? Math.max(...positions) : 0,
  };
}
